/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDimensions_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_user">;
    readonly " $refType": "SbRespRefineMenuFilterDimensions_user";
};
export type SbRespRefineMenuFilterDimensions_user$data = SbRespRefineMenuFilterDimensions_user;
export type SbRespRefineMenuFilterDimensions_user$key = {
    readonly " $data"?: SbRespRefineMenuFilterDimensions_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDimensions_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterDimensions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '5c095c96fa002ff53f39d14e3317552f';
export default node;
